import React from 'react';
import clsx from 'clsx';

const styles = {
  base: [
    'inline-flex items-center rounded-full font-medium',
  ],
  sizes: {
    xs: 'px-1.5 py-0.5 text-xs',
    sm: 'px-2 py-1 text-xs',
    md: 'px-2.5 py-1 text-sm',
    lg: 'px-3 py-1.5 text-sm',
  },
  variants: {
    default: [
      'bg-gray-100 text-gray-800',
      'dark:bg-gray-800 dark:text-gray-300',
    ],
    primary: [
      'bg-emerald-100 text-emerald-800',
      'dark:bg-emerald-900/20 dark:text-emerald-400',
    ],
    secondary: [
      'bg-zinc-100 text-zinc-800',
      'dark:bg-zinc-800 dark:text-zinc-300',
    ],
    success: [
      'bg-green-100 text-green-800',
      'dark:bg-green-900/20 dark:text-green-400',
    ],
    danger: [
      'bg-red-100 text-red-800',
      'dark:bg-red-900/20 dark:text-red-400',
    ],
    warning: [
      'bg-yellow-100 text-yellow-800',
      'dark:bg-yellow-900/20 dark:text-yellow-400',
    ],
    info: [
      'bg-blue-100 text-blue-800',
      'dark:bg-blue-900/20 dark:text-blue-400',
    ],
    outline: [
      'bg-transparent border border-current text-gray-500',
      'dark:text-gray-400',
    ],
  },
  dotVariants: {
    default: 'bg-gray-500',
    primary: 'bg-emerald-500',
    secondary: 'bg-zinc-500',
    success: 'bg-green-500',
    danger: 'bg-red-500',
    warning: 'bg-yellow-500',
    info: 'bg-blue-500',
    outline: 'bg-gray-500',
  },
};

export const Badge = ({
  children,
  className = '',
  variant = 'default',
  size = 'md',
  dot = false,
  ...props
}) => {
  return (
    <span
      className={clsx(
        styles.base,
        styles.sizes[size],
        styles.variants[variant],
        className
      )}
      {...props}
    >
      {dot && (
        <span
          className={clsx(
            'mr-1.5 h-1.5 w-1.5 rounded-full',
            styles.dotVariants[variant]
          )}
        />
      )}
      {children}
    </span>
  );
};

// Predefined badge variants
export const DefaultBadge = (props) => <Badge variant="default" {...props} />;
export const PrimaryBadge = (props) => <Badge variant="primary" {...props} />;
export const SecondaryBadge = (props) => <Badge variant="secondary" {...props} />;
export const SuccessBadge = (props) => <Badge variant="success" {...props} />;
export const DangerBadge = (props) => <Badge variant="danger" {...props} />;
export const WarningBadge = (props) => <Badge variant="warning" {...props} />;
export const InfoBadge = (props) => <Badge variant="info" {...props} />;
export const OutlineBadge = (props) => <Badge variant="outline" {...props} />;
